import '../../styles/templates/pages/page.benefits-grid.scss';
import { resizeObserver } from '../utils/helpers';
import './product/components/AccessBenefitsGrid';

window.addEventListener('DOMContentLoaded', () => {
  var loyaltyGridWebview = document.querySelector('.loyalty-grid-webview');
  if (loyaltyGridWebview) resizeObserver.observe(loyaltyGridWebview);
});

export {};
